<template>
  <div class="container">
    <ul class="items">
      <li
        v-for="(item, index) in unitAccountData"
        :key="index"
        @click="$emit('showDetail', item)"
      >
        <span class="texts">
          <label>{{ `${__("The year")} ${item.year}` }}</label>
          <span>{{
            __("A total of {0} NIS remains to be paid for this year", [
              __u_value__({ value:item.total, unit: 'number-f' })
,
            ])
          }}</span>
        </span>
        <i-icon :name="$store.state.local.dir==='rtl'?'arrow-alt':'arrow'" />
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    unitAccountData: Array,
  },


  emits: ["showDetail"],
  // watch: {
  //   unitAccountData(newValue, oldValue) {
  //     console.log(newValue, oldValue);
  //   }
  // },
};
</script>

<style scoped>
.items {
  margin: 0;
  padding: 0;

  list-style: none;
}

.items li {
  border-bottom: 1px solid var(--color-border);
  gap: 20px;
  display: grid;
  grid-template-columns: 1fr 34px;

  padding: 20px 0;

  color: inherit;
  text-decoration: none;
}

.items li .texts {
  display: flex;
  flex-direction: column;

  font-size: 15px;
  line-height: 0.93;
  letter-spacing: 0.48px;
}

.items li .texts label {
  margin-bottom: 7px;

  font-size: 18px;
  line-height: 1.14;
  letter-spacing: 0.58px;

  color: var(--color-primary);
}

.items li:deep(.svg) {
  width: 34px;
  height: 34px;

  color: var(--color-success);
}
</style>
